import styled from 'styled-components';

import { SettingsComponentMenu } from '../settings/settings-component-menu.style';

export const CustomDragContainer = styled.div`
  position: fixed;
  pointer-events: none;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 102;
  ${SettingsComponentMenu} {
    display: none;
  }
`;
